import {Component} from 'react';
import {FormError} from './form-errors';
import {RadioBox} from './radiobox';
import FormIndividu from './form-individu';
import analytics, { FIELD_IDS, CONDITIONAL_IDS } from '../../services/analytics';

const STEP_NUMBER = 3;

class Conjoint extends Component {
	constructor (props){
		super(props);

		// Récupérer le field tracker pour le tracking granulaire des champs
		this.fieldTracker = analytics.getFieldTracker();

		this.state = {
			en_couple : this.props.enCouple ? true : null,
			conjoint : {
                age : 1,
                etudiant: false,
                chomeur_longue_duree: false,
                handicap: false,
                inapte_travail: false,
                enceinte: false,
                echelon_bourse: false,
                nationalite: 'FR',
            },
            rsa_isolement_recent:null,
			validations :[],

			showConjointForm :false,
			statut_marital :this.props.statutMarital,

		};

		 this.optionsStatutMarital = [
        	{ 
        	  id: 1,
        	  name: 'En Union  libre',
        	  value :'non_renseigne',
        	},
            {
              id: 2,
              name: 'Marié-e',
              value:'marie',
          	},
            {
              id: 3,
              name: 'Pacsé-e',
              value: 'pacse',
          	}
        ];
		
	}
	captureIsolementRecent= (newVal)=>{
		
		this.setState(()=>({rsa_isolement_recent:JSON.parse(newVal)}));
		
	}

	changeDureeSejourValide = (e)=>{
		const dureeSejourValide = e.target.checked;
        this.setState( ({conjoint})=> {
            if ( dureeSejourValide  === true) {
                conjoint.duree_possession_titre_sejour =   25;
            } else {
                conjoint.duree_possession_titre_sejour = 0;
            }
            return {conjoint:conjoint};
        });
	}
	handleChangeEnCouple = (newVal)=>{
		
		this.setState( ()=>{
			return {en_couple : JSON.parse(newVal)};
		});
	}
	
	handleChangeStatutCouple = (e) =>{
		const newVal  = e.target.value;
		this.setState( ()=>{
			return {statut_marital : newVal};
		}); 
	}

    validateQuestionCouple = async (e)=>{
    	this.setState(()=>{
    		return {showConjointForm : this.state.en_couple}
    	});
        let validations = [];
    	if (this.state.en_couple === null){
    		let error = "Veuillez renseigner si vous êtes en couple.";
    		validations.push(error);
    		// Tracker l'erreur de validation
    		analytics.trackValidationError(STEP_NUMBER, 'PARTNER_STATUS_REQUIRED', 'en_couple');
    	}

       	if (this.state.en_couple === false) {
    		let data ={
    			"famille":{
    				en_couple:false
    			},
    			"demandeur":{
    				statut_marital : "celibataire"
    			},
    			"conjoint":false
    		};
    		var validData= true;
    		if (this.props.hasEnfant ){

    			if (this.state.rsa_isolement_recent === null){
    				let error = "Veuillez renseigner depuis combien de temp vous vivez seul·e";
    				validations.push(error);
    				validData=false;
    				// Tracker l'erreur de validation
    				analytics.trackValidationError(STEP_NUMBER, 'ISOLATION_DURATION_REQUIRED', 'rsa_isolement_recent');
    			}
    			data.famille.rsa_isolement_recent = this.state.rsa_isolement_recent;

    		}

    		if (validData){
    			// Tracker que l'utilisateur n'a pas de conjoint et sync Supabase
    			analytics.setUserHasPartner(false);
    			await analytics.updateUserProfile({ has_partner: false });
    			this.props.validateStep(data);
    		}

    	}

    	if (validations.length > 0 ) {
    		this.setState({validations:validations})
    		return false;
    	}
    	return true;
    }

    validateConjoint = (newData)=>{
		this.setState(()=>{
			return {conjoint:newData}
		}, async ()=>{

        	let data = {
        		"conjoint" : this.state.conjoint,
        		"famille": {
        			en_couple : true
        		}

        	};
        	data.conjoint.role ="conjoint";
        	if (this.state.statut_marital) {
        		data.demandeur = {
        			statut_marital : this.state.statut_marital,
        		}
        	}

        	delete data.conjoint.situations;

    		// Tracker que l'utilisateur a un conjoint et sync Supabase
    		analytics.setUserHasPartner(true);
    		await analytics.updateUserProfile({ has_partner: true });
    		this.props.validateStep(data);
    	});

    }

    questionEncouple = () => {
		return <>
			<div className="question">
	            <div className="question_couple">

					<RadioBox
						name="en_couple"
						options={{"En couple":true, "Seul":false}}
						handler={(val) => {
							this.fieldTracker.onFieldFocus(STEP_NUMBER, FIELD_IDS.STEP_PARTNER.en_couple, this.state.en_couple);
							this.handleChangeEnCouple(val);
							this.fieldTracker.onFieldBlur(STEP_NUMBER, FIELD_IDS.STEP_PARTNER.en_couple, val);
							// Tracker l'affichage du formulaire conjoint si en couple
							if (JSON.parse(val) === true) {
								analytics.trackConditionalShown(STEP_NUMBER, CONDITIONAL_IDS.PARTNER_FORM, 'en_couple');
							}
							// Tracker l'affichage de la question isolement si seul avec enfants
							if (JSON.parse(val) === false && this.props.hasEnfant) {
								analytics.trackConditionalShown(STEP_NUMBER, CONDITIONAL_IDS.ISOLATION_DURATION, 'en_couple');
							}
						}}
						defaultValue={this.state.en_couple}
					><h3> Vivez-vous seul(e) ou en couple ?</h3></RadioBox>

			    </div>
			</div>
			{
				( this.state.en_couple) ?
				<div className ="question statut-couple">
					<h3><label> Quel est le statut de votre couple ?</label><br/></h3>
					<select
						onChange={(e) => {
							this.fieldTracker.onFieldFocus(STEP_NUMBER, FIELD_IDS.STEP_PARTNER.statut_marital, this.state.statut_marital);
							this.handleChangeStatutCouple(e);
							this.fieldTracker.onFieldBlur(STEP_NUMBER, FIELD_IDS.STEP_PARTNER.statut_marital, e.target.value);
						}}
						onFocus={() => this.fieldTracker.onFieldFocus(STEP_NUMBER, FIELD_IDS.STEP_PARTNER.statut_marital, this.state.statut_marital)}
						onBlur={() => this.fieldTracker.onFieldBlur(STEP_NUMBER, FIELD_IDS.STEP_PARTNER.statut_marital, this.state.statut_marital)}
						defaultValue={this.state.statut_marital}
					>
						{ this.optionsStatutMarital.map ( (statut) => (
							 <option value={statut.value} key={statut.id}>{statut.name}</option>
							))}
					</select>
				</div>
				: (this.state.en_couple===false && this.props.hasEnfant) ?
				<div className="question parent-isole">
					<RadioBox
						name="rsa_isolement_recent"
						options={{
							"Moins de 18 mois":true,
							"Plus de 18 mois":false
						}}
						defaultValue={this.state.rsa_isolement_recent}
						handler={(val) => {
							this.fieldTracker.onFieldFocus(STEP_NUMBER, FIELD_IDS.STEP_PARTNER.isolement_recent, this.state.rsa_isolement_recent);
							this.captureIsolementRecent(val);
							this.fieldTracker.onFieldBlur(STEP_NUMBER, FIELD_IDS.STEP_PARTNER.isolement_recent, val);
						}}
						><h3>Depuis combien de temps vivez-vous seul·e ?</h3></RadioBox>
				</div> :''
			}
			<div className="error-container">
				<FormError errors={this.state.validations}/>
			</div>
			<button onClick={this.validateQuestionCouple}>Valider</button>
			<div className="button-container previous">
						<button onClick={this.restart}> Recommencer </button>
			</div>
		</>
	}

	formConjoint = ()=> {
		return <FormIndividu saveData={this.validateConjoint} />;
	}

	restart = ()=> {
		this.props.restart();
	}

	render (){
		return <div className="step-inner-container">
		<p className="step-title"><strong>Conjoint(e)</strong></p> 
			{
				(this.state.showConjointForm ) ?
				  (this.formConjoint()) :
				  (this.questionEncouple())

			}

		</div>

	}
}

export default Conjoint;
